export default __webpack_public_path__ + "static/media/foto_746x720.65aa72ec.png";